import { Box, Image, Stack } from "@mantine/core";
import type { JSX } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import classes from "./ImageThreadsPage.module.css";

interface IterationNode {
    id: number;
    file: { src: string } | null;
}

interface Props {
    id: number;
    iterations: {
        edges: Array<{ node: IterationNode }>;
    };
}

export default function ImageThreadCard({ id, iterations }: Props): JSX.Element {
    const edges = iterations.edges;
    const latest = edges.length > 0 ? edges[0].node : undefined;
    const { search } = useLocation();

    return (
        <Link to={`/image-threads/${id}${search}`} className={classes.link}>
            <Stack>
                {latest?.file?.src && <Image src={latest.file.src} height={200} fit="contain" radius="sm" />}
                <Box>Thread #{id}</Box>
            </Stack>
        </Link>
    );
}
